import { TenantDisplayPalette } from '@askporter/grieg-types';
import { createTheme, Theme } from '@material-ui/core';
import { customPalette, customTypography, breakpoints, customComponents } from './options';

/**
 * Creates the Material UI theme object with our design tokens
 *
 * @param configPalette - the tenant's colours conforming to the ConfigPalette type
 *
 * @returns Theme - the MUI Theme object
 */
export const createAPTheme = (configPalette: TenantDisplayPalette): Theme =>
  createTheme({
    components: customComponents(configPalette).components,
    breakpoints,
    spacing: (factor: number) => `${0.25 * factor}rem`,
    typography: customTypography.typography,
    palette: customPalette(configPalette),
  });

export { fallbackTheme } from './fallbackTheme';
